import type Keycloak from 'keycloak-js';
import { AUTH_CONFIG, USER_ROLES } from '@/config/constants';
import { DEVELOPER_ROLE, hasDocumentationRole } from '@/features/developers/access';

const ROLE_MAP: Record<string, string> = {
  admin: 'Administrator',
  advanced: 'AdvancedUser',
  viewer: 'User',
};

/**
 * The panel role comes from the client roles alone. Without one, a documentation realm role
 * makes a documentation-only user; with neither, the user has no access (never a default role).
 */
function mapRole(roles: string[], token: unknown): string {
  for (const r of roles) {
    if (ROLE_MAP[r]) return ROLE_MAP[r];
  }
  return hasDocumentationRole(token) ? DEVELOPER_ROLE : USER_ROLES.NO_ACCESS;
}

export function syncAuthToLocalStorage(sso: Keycloak): void {
  const token = sso.token;
  const parsed = sso.tokenParsed;
  if (!token || !parsed) { clearSsoAuthData(); return; }

  const clientId = sso.clientId ?? 'kyc';
  const appRoles: string[] = (parsed as any).resource_access?.[clientId]?.roles ?? [];
  const role = mapRole(appRoles, parsed);

  localStorage.setItem(AUTH_CONFIG.TOKEN_KEY, token);
  localStorage.setItem(AUTH_CONFIG.ROLE_KEY, role);
  localStorage.setItem(AUTH_CONFIG.USER_KEY, JSON.stringify({
    id: parsed.sub || '',
    email: (parsed as any).email || '',
    fullName: (parsed as any).name || (parsed as any).preferred_username || '',
    role,
  }));
}

export function clearSsoAuthData(): void {
  localStorage.removeItem(AUTH_CONFIG.TOKEN_KEY);
  localStorage.removeItem(AUTH_CONFIG.USER_KEY);
  localStorage.removeItem(AUTH_CONFIG.ROLE_KEY);
}
